import { action, makeObservable, observable } from 'mobx';
import { Injectable } from './service.base';

@Injectable()
export class RemoveCardDialogService {
    @observable public open = false;

    constructor() {
        makeObservable(this);
    }

    @action
    handleOpen = () => {
        this.open = true;
    };

    @action
    handleClose = () => {
        this.open = false;
    };
}
